import * as React from "react";

import NavBar from '../components/NavBar';
import FeatureSection from '../components/FeatureSection';
import Footer from '../components/Footer';
import AboutUs from '../components/AboutUs';

import "../styles/main.css";
import OurServices from "../components/OurServices";
import FindUs from "../components/FindUs";
import OurOffice from "../components/OurOffice";

export const App = () => (
  <div className="w-5/6 justify-center mx-auto">
    <NavBar />
    <FeatureSection />
    <AboutUs />
    <OurServices />
    <FindUs />
    <OurOffice />
    <Footer />
  </div>
);